module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgdmlld0JveD0iLTggMCAzMiAzMiI+CiAgICA8cGF0aCBkPSJNMTQuMDgwIDQuOHEyLjg4IDAgMi44OCAyLjA0OHYxOC4yNHEwIDIuMTEyLTIuODggMi4xMTJ0LTIuODgtMi4xMTJ2LTE4LjI0cTAtMi4wNDggMi44OC0yLjA0OHpNMi44OCA0LjhxMi44OCAwIDIuODggMi4wNDh2MTguMjRxMCAyLjExMi0yLjg4IDIuMTEydC0yLjg4LTIuMTEydi0xOC4yNHEwLTIuMDQ4IDIuODgtMi4wNDh6Ij48L3BhdGg+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/aplayer/assets/pause.svg
// module id = 7O3t
// module chunks = 30